import React from 'react';
import personImage from '../img/photo.png';

function HeroSection() {
  return (
    <section className="hero-section">
      {/* Левый блок с текстом */}
      <div className="hero-left">
        <div className="promo-labels">
          <span className="label label-level">4500+ учеников</span>
          <span className="label label-discount">Стоимость 250 000 тенге</span>
        </div>

        <h1 className="hero-title">Эксперт в области маркетинговых инноваций</h1>
        <p className="hero-subtitle">
        Наргыз Аманбекова – ведущий эксперт в области маркетинговых инноваций и персонализированной рекламы
        </p>

        <ul className="benefits-list">
          <li>Составите персональную траекторию развития с учётом ваших целей и интересов</li>
          <li>Разработаете для своего проекта маркетинговую стратегию и план продвижения</li>
          <li>Научитесь управлять маркетинговыми процессами и ресурсами команды для достижения твёрдого результата</li>
        </ul>

        <a className="cta-button" href="#contact-form">Записаться на курс </a>
      </div>

      {/* Правый блок с изображением */}
      <div className="hero-right">
        <div className="person-card">
          <img src={personImage} alt="Наргыз Аманбекова" className="person-img" />
          <div className="person-info">
            <strong>Наргыз Аманбекова</strong>
            <span>Автор курса</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
